













import {Vue} from '../../constants/constants'
export default Vue.component('form-feedback', {
	data () {
		return {
			error: '',
			success: ''
		}
	},
	methods: {
		showError (error) {
			this.error = error
			this.success = ''
		},
		showSuccess (success) {
			this.success = success
			this.error = ''
		},
		clear () {
			if (this.error || this.success) {
				this.error = ''
				this.success = ''
			}
		}
	}
})
